import type { ILocTreeItem } from '../types'

export type ILocItemsResponse = ILocTreeItem[]

export interface ILocTreeByKeywordResponse {
    query_results: {
        cls_tree: ILocTreeItem
    }[]
    h_words: string[]
}

export interface ILocPredictRequest {
    url: string
}

export type ILocPredictResponse = ILocTreeItem[]

export interface ILocItem {
    id: string
    desc: string
}

export interface ISaveConditionsRequest {
    url: string
    country: string[]
    loc_items: ILocItem[]
    main_field: string
    apply_start_time: string
}

export interface IPImageFtoSearchApi {
    getLOCItemsData: (code?: string) => Promise<ILocItemsResponse>
    getLOCTreeByKeyword: (keyword?: string) => Promise<ILocTreeByKeywordResponse>
    predictLOC: (request: ILocPredictRequest) => Promise<ILocPredictResponse>
    saveConditions: (jobId: string, request: ISaveConditionsRequest) => Promise<any>
}

export const IPImageFtoSearchApi = Symbol('IPImageFtoSearchApi')
